import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';
import OrzelKsiazkaIcon from '../../img/icons/orzel_ksiazka.png';

// Popup po onboardingu — tylko dla userow, ktorzy zadeklarowali podstawe + rozszerzenie.
// Tlumaczy, dlaczego aplikacja startuje w torze podstawy.
const DomainStartPopup = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) posthog.capture('domain_start_popup_viewed');
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-[9998] p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-sm w-full text-center transform animate-swoosh-in border-4 border-white ring-4 ring-white/20">

                <div className="flex justify-center mb-4">
                    <img src={OrzelKsiazkaIcon} alt="Orzeł z książką" className="w-28 h-28" />
                </div>

                <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-3 uppercase font-bold">
                    Zaczynamy od podstawy!
                </h2>
                <p className="text-gray-600 text-sm mb-6 leading-relaxed px-2">
                    Poziom Podstawa/Rozszerzenie możesz zmieniać kiedy chcesz w ustawieniach.
                </p>

                <button
                    onClick={onClose}
                    className="w-full font-apotek tracking-widest uppercase text-sm text-white font-bold py-3 px-4 rounded-xl shadow-2xl transform transition-transform active:scale-95 bg-[#233855] hover:bg-[#1a2b42]"
                >
                    OK, Rozumiem!
                </button>
            </div>
        </div>,
        document.body
    );
};

export default DomainStartPopup;
